/* eslint-disable react/no-multi-comp */
/* eslint-disable react/display-name */
import React, { lazy } from 'react';
import { Redirect } from 'react-router-dom';
import AuthLayout from './layouts/Auth';
import ErrorLayout from './layouts/Error';
import DashboardLayout from './layouts/Dashboard';
import DashboardDefaultView from './views/DashboardDefault';

export default [
  {
    path: '/',
    exact: true,
    component: () => <Redirect to="/auth/login" />
  },
  {
    path: '/auth',
    component: AuthLayout,
    routes: [
      {
        path: '/auth/login',
        exact: true,
        component: lazy(() => import('src/views/Login'))
      },
      {
        path: '/auth/super/login',
        exact: true,
        component: lazy(() => import('src/views/Login/SuperAdmin'))
      },
      {
        path: '/auth/logout',
        exact: true,
        component: lazy(() => import('src/components/Logout'))
      },
      {
        path: '/auth/back-to-companies',
        exact: true,
        component: lazy(() => import('src/components/BackToCompanies'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/errors',
    component: ErrorLayout,
    routes: [
      {
        path: '/errors/error-401',
        exact: true,
        component: lazy(() => import('src/views/Error401'))
      },
      {
        path: '/errors/error-404',
        exact: true,
        component: lazy(() => import('src/views/Error404'))
      },
      {
        path: '/errors/error-500',
        exact: true,
        component: lazy(() => import('src/views/Error500'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  },
  {
    path: '/super',
    component: DashboardLayout,
    routes: [
      {
        path: '/super/create-company',
        component: lazy(() => import('src/views/superAdmin/views/Company'))
      },
      {
        path: '/super/company/:companyId',
        component: lazy(() => import('src/views/superAdmin/views/Company'))
      },
      {
        path: '/super/companies',
        component: lazy(() => import('src/views/superAdmin/CompaniesList'))
      },
      {
        path: '/super/integration-executions',
        component: lazy(() =>
          import(
            'src/views/superAdmin/IntegrationExecutions'
          )
        )
      },
      {
        path: 'settings/super/company/:companyId/subsidiary',
        exact: true,
        component: lazy(() =>
          import('src/views/superAdmin/Subsidiary/AddSubsidiary')
        )
      },
      {
        path: '/super/settings/company/:companyId/subsidiary/:subsidiaryId',
        exact: true,
        component: lazy(() =>
          import('src/views/superAdmin/Subsidiary/EditSubsidiary')
        )
      },
      {
        path: '/super/settings/company/:companyId/subsidiary',
        exact: true,
        component: lazy(() =>
          import('src/views/superAdmin/Subsidiary/AddSubsidiary')
        )
      },
      {
        path: '/super/settings/company/:companyId/terms-and-conditions',
        exact: true,
        component: lazy(() =>
          import('src/views/superAdmin/TermsAndConditions/AddTermsDocument')
        )
      },
      {
        path:
          '/super/settings/company/:companyId/terms-and-conditions/:termsDocumentId',
        exact: true,
        component: lazy(() =>
          import('src/views/superAdmin/TermsAndConditions/ViewTermsDocument')
        )
      },
      {
        path: '/super/notifications',
        exact: true,
        component: lazy(() =>
          import('src/views/superAdmin/SendPushNotifications')
        )
      },
      {
        path: '/super/account-settings/2fa',
        exact: true,
        component: lazy(() =>
          import('src/views/superAdmin/TwoFactorAuthSettings')
        )
      },
      {
        path: '/super/account-settings/manage-account',
        exact: true,
        component: lazy(() => import('src/views/superAdmin/ManageAccount'))
      },
      {
        path: '/super/payments',
        exact: true,
        component: lazy(() => import('src/views/superAdmin/Payments'))
      },
      {
        path: '/super/payments/:paymentId',
        exact: true,
        component: lazy(() =>
          import('src/views/superAdmin/Payments/PaymentSummary')
        )
      },
      {
        path: '/super/support/payments',
        exact: true,
        component: lazy(() =>
          import('src/views/superAdmin/Support/SearchPayments.js')
        )
      },
      {
        path: '/super/support/employees',
        exact: true,
        component: lazy(() =>
          import('src/views/superAdmin/Support/SearchUsers.js')
        )
      },
      {
        path: '/super/support/companies',
        exact: true,
        component: lazy(() =>
          import('src/views/superAdmin/Support/SearchCompanies.js')
        )
      },
      {
        path: '/super/support/sales-commissions',
        exact: true,
        component: lazy(() =>
          import('src/views/superAdmin/Support/SearchCommissions.js')
        )
      },
      {
        path: '/super/superadmins',
        exact: true,
        component: lazy(() => import('src/views/superAdmin/SuperAdminsList'))
      },
      {
        path: '/super/billing-note',
        exact: true,
        component: lazy(() => import('src/views/superAdmin/BillingNote'))
      }
    ]
  },
  {
    route: '*',
    component: DashboardLayout,
    routes: [
      {
        path: '/overview',
        exact: true,
        component: DashboardDefaultView
      },
      {
        path: '/company-status',
        exact: true,
        component: lazy(() => import('src/views/superAdmin/CompanyStatus'))
      },
      {
        path: '/exclusion-list',
        exact: true,
        component: lazy(() => import('src/views/EmployeesBlacklist'))
      },
      {
        path: '/employees',
        exact: true,
        component: lazy(() => import('src/views/AvailableSoon'))
      },
      {
        path: '/history',
        exact: true,
        component: lazy(() => import('src/views/History'))
      },
      {
        path: '/add-employee',
        exact: true,
        component: lazy(() => import('src/views/AddEmployee'))
      },
      {
        path: '/edit-employee/:personalId',
        exact: true,
        component: lazy(() => import('src/views/EditEmployee'))
      },
      {
        path: '/list-employees',
        exact: true,
        component: lazy(() => import('src/views/EmployeeList'))
      },
      {
        path: '/list-admins-f',
        exact: true,
        component: lazy(() => import('src/views/AdminListForFull'))
      },
      {
        path: '/import-csv/:tab?',
        exact: true,
        component: lazy(() => import('src/views/UploadCSV'))
      },
      {
        path: '/payroll',
        exact: true,
        component: lazy(() => import('src/views/Payroll'))
      },
      {
        path: '/settings/:tab?',
        exact: true,
        component: lazy(() => import('src/views/Settings'))
      },
      {
        path: '/help',
        exact: true,
        component: lazy(() => import('src/views/Help'))
      },
      {
        path: '/logout',
        exact: true,
        component: lazy(() => import('src/views/AvailableSoon'))
      },
      {
        component: () => <Redirect to="/errors/error-404" />
      }
    ]
  }
];
